module.exports = __webpack_public_path__ + "static/media/Elise Lockwood.c5c8d023.png";